import printError from '../components/Common/PrintError';
import {
  REQUEST_PO_PDF,
  FETCH_PO_PDF_SUCCESS,
  REQUEST_SI_PDF,
  FETCH_SI_PDF_SUCCESS,
  FETCH_SI_PDF_FAILURE,
  REQUEST_SI_RETURN_PDF,
  FETCH_SI_RETURN_PDF_SUCCESS,
  FETCH_SI_RETURN_PDF_FAILURE,
  REQUEST_PURCHASE_RETURN_PDF,
  FETCH_PURCHASE_RETURN_PDF_SUCCESS,
  REQUEST_PURCHASE_REFERENCE_PDF,
  FETCH_PURCHASE_REFERENCE_PDF_SUCCESS,
  REQUEST_WR_PDF,
  FETCH_WR_PDF_SUCCESS,
  REQUEST_AR_PDF,
  FETCH_AR_PDF_SUCCESS,
  REQUEST_AP_PDF,
  FETCH_AP_PDF_SUCCESS,
  REQUEST_ROUTING_PDF,
  REQUEST_ROUTING_PDF_SUCCESS,
  REQUEST_ROUTING_PDF_FAILURE,
  REQUEST_DISPATCH_PICKING_LIST_PDF,
  REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS,
  REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE,
  REQUEST_DISPATCH_PACKING_LIST_PDF,
  REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS,
  REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE,
  REQUEST_DISPATCH_SALES_INVOICE_PDF,
  REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS,
  REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE,
  REQUEST_SI_NOSUBTOTAL_PDF,
  REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS,
  REQUEST_PO_NOSUBTOTAL_PDF,
  REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS,
  REQUEST_SI_RETURN_NOSUBTOTAL_PDF,
  REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS,
  REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL,
  REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS,
} from '../actions/type';

const INITIAL_STATE = {
  requestingPurchaseOrderPdf: false,
  purchaseOrderPdf: null,
  requestingSalesInvoicePdf: false,
  requestingSalesInvoiceReturnPdf: false,
  salesInvoicePdf: null,
  salesInvoiceReturnPdf: null,
  requestingWarehouseReceivePdf: false,
  warehouseReceivePdf: null,
  requestingArReport: false,
  arReport: null,
  requestingApReport: false,
  apReport: null,
  printSalesInvoiceIsLoading: false,
  requestingPurchaseReturnPdf: false,
  purchaseReturnPdf: null,
  requestingPurchaseReferencePdf: false,
  purchaseReferencePdf: null,
  requestingRoutingPdf: false,
  routingPdf: null,
  routingPdfFailure: false,
  requestingPickingListPdf: false,
  pickingListPdf: null,
  pickingListPdfFailure: false,
  requestingPackingListPdf: false,
  packingListPdf: null,
  packingListPdfFailure: false,
  requestingDispatchSalesInvoicePdf: false,
  dispatchSalesInvoicePdf: null,
  dispatchSalesInvoicePdfFailure: false,
  requestingPurchaseOrderPdfNs: false,
  purchaseOrderPdfNs: null,
  salesorderPdfNs: null,
  requestingSalesInvoicePdfsNs: false,
  salesInvoiceReturnPdfNs: null,
  purchaseReturnPdfNs: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_PO_PDF:
      return { ...state, requestingPurchaseOrderPdf: true, purchaseOrderPdf: null };
    case FETCH_PO_PDF_SUCCESS:
      return { ...state, requestingPurchaseOrderPdf: false, purchaseOrderPdf: action.payload.data };
    case REQUEST_PO_NOSUBTOTAL_PDF:
      return { ...state, requestingPurchaseOrderPdfNs: true, purchaseOrderPdfNs: null };
    case REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS:
      return { ...state, requestingPurchaseOrderPdfNs: false, purchaseOrderPdfNs: action.payload.data };  
    case REQUEST_SI_PDF:
      return {
        ...state, requestingSalesInvoicePdf: true, salesInvoicePdf: null, printSalesInvoiceIsLoading: true,
      };
    case FETCH_SI_PDF_SUCCESS:
      return {
        ...state, requestingSalesInvoicePdf: false, salesInvoicePdf: action.payload.data, printSalesInvoiceIsLoading: false,
      };
    case FETCH_SI_PDF_FAILURE:
      const salesInvoicePdfError = action.payload || { message: action.payload.message };
      alert(JSON.stringify(salesInvoicePdfError));
      return {
        ...state, requestingSalesInvoicePdf: false, salesInvoiceReturnPdfError, printSalesInvoiceIsLoading: false,
      };
    case REQUEST_SI_NOSUBTOTAL_PDF: 
      return {
        ...state, salesorderPdfNs: null, requestingSalesInvoicePdf: true
      };
    case REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS: 
      return {
        ...state, salesorderPdfNs: action.payload.data, requestingSalesInvoicePdf: false
      };
    case REQUEST_SI_RETURN_PDF:
      return {
        ...state, requestingSalesInvoiceReturnPdf: true, salesInvoiceReturnPdf: null, printSalesInvoiceIsLoading: true,
      };
    case FETCH_SI_RETURN_PDF_SUCCESS:
      return {
        ...state, requestingSalesInvoiceReturnPdf: false, salesInvoiceReturnPdf: action.payload.data, arReport: action.payload.data, printSalesInvoiceIsLoading: false,
      };
    case FETCH_SI_RETURN_PDF_FAILURE:
      const salesInvoiceReturnPdfError = action.payload || { message: action.payload.message };
      alert(JSON.stringify(salesInvoiceReturnPdfError));
      return {
        ...state, requestingSalesInvoiceReturnPdf: false, salesInvoiceReturnPdfError, printSalesInvoiceIsLoading: false,
      };
    case REQUEST_WR_PDF:
      return { ...state, requestingWarehouseReceivePdf: true, warehouseReceivePdf: null };
    case FETCH_WR_PDF_SUCCESS:
      return { ...state, requestingWarehouseReceivePdf: false, warehouseReceivePdf: action.payload.data };
    case REQUEST_AR_PDF:
      return { ...state, requestingArReport: true, arReport: null };
    case FETCH_AR_PDF_SUCCESS:
      return { ...state, requestingArReport: false, arReport: action.payload.data };
    case REQUEST_PURCHASE_RETURN_PDF:
      return {
        ...state,
        requestingPurchaseReturnPdf: true,
        purchaseReturnPdf: null,
      };
    case FETCH_PURCHASE_RETURN_PDF_SUCCESS:
      return {
        ...state,
        requestingPurchaseReturnPdf: false,
        purchaseReturnPdf: action.payload.data,
      };

    case REQUEST_PURCHASE_REFERENCE_PDF:
      return {
        ...state,
        requestingPurchaseReferencePdf: true,
        purchaseReferencePdf: null,
      };
    case FETCH_PURCHASE_REFERENCE_PDF_SUCCESS:
      return {
        ...state,
        requestingPurchaseReferencePdf: false,
        purchaseReferencePdf: action.payload.data,
      };

    case REQUEST_AP_PDF:
      return {
        ...state,
        requestingApReport: true,
        apReport: null,
      };
    case FETCH_AP_PDF_SUCCESS:
      return {
        ...state,
        requestingApReport: false,
        apReport: action.payload.data,
      };
      
    case REQUEST_ROUTING_PDF:
      return { ...state, requestingRoutingPdf: true, routingPdf: null };
    case REQUEST_ROUTING_PDF_SUCCESS:
      return { ...state, requestingRoutingPdf: false, routingPdf: action.payload.data };
    case REQUEST_ROUTING_PDF_FAILURE:
      printError(action.payload);
      return { ...state, requestingRoutingPdf: false, routingPdfFailure: true };
    case REQUEST_DISPATCH_PICKING_LIST_PDF:
      return { ...state, requestingPickingListPdf: true, pickingListPdf: null };
    case REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS:
      return { ...state, requestingPickingListPdf: false, pickingListPdf: action.payload.data };
    case REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE:
      printError(action.payload);
      return { ...state, requestingPickingListPdf: false, pickingListPdfFailure: true };
    case REQUEST_DISPATCH_PACKING_LIST_PDF:
      return { ...state, requestingPackingListPdf: true, packingListPdf: null };
    case REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS:
      return { ...state, requestingPackingListPdf: false, packingListPdf: action.payload.data };
    case REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE:
      printError(action.payload);
      return { ...state, requestingPackingListPdf: false, packingListPdfFailure: true };
    case REQUEST_DISPATCH_SALES_INVOICE_PDF:
      return { ...state, requestingDispatchSalesInvoicePdf: true, dispatchSalesInvoicePdf: null };
    case REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS:
      return { ...state, requestingDispatchSalesInvoicePdf: false, dispatchSalesInvoicePdf: action.payload.data };
    case REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE:
      printError(action.payload);
      return { ...state, requestingDispatchSalesInvoicePdf: false, dispatchSalesInvoicePdfFailure: true };
    case REQUEST_SI_RETURN_NOSUBTOTAL_PDF:
      return {
        ...state, requestingSalesInvoiceReturnPdf: true, salesInvoiceReturnPdfNs: null, printSalesInvoiceIsLoading: true,
      };
    case REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS:
        return {
          ...state, requestingSalesInvoiceReturnPdf: false, salesInvoiceReturnPdfNs: action.payload.data, printSalesInvoiceIsLoading: false,
        };
    case REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL:
      return {
        ...state, requestingPurchaseReturnPdf: true, purchaseReturnPdfNs: null
      };
    case REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS:
      return {
        ...state, requestingPurchaseReturnPdf: false, purchaseReturnPdfNs: action.payload.data
      };
    default:  
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/print_reducer.js